import React, { Component } from "react";
import SalesDataTable from "./salesDataTable/salesDataTable";
import SalesSearchBox from "./salesSearchBox/SalesSearchBox";
import moment from "moment";
import CommonHeader from "./headers/commonHeader";
import { connect } from "react-redux";
import { logoutCall } from "../util/userManager";
import { userActions } from "../actions";
import BlockUi from "react-block-ui";

const initialState = {
  invoiceFromDate: null,
  clearSearch: false,
  clearButton: true,
  toDateErr: "",
  records: 0,
  invoiceToDate: null,
  checkFromDate: false,
  source: "",
  typeOfInvoice: "",
  nmsc: "",
  edNumber: "",
  vinNumber: "",
  invoiceNumber: "",
  vesselName: "",
  orgCode: "",
  status: 0,
  showSalesResults: false,
  hub: "",
  srcVatCode: "",
  tgtVatCode: "",
  tabledata: [],
  bulkfilename: [],
  blocking: false,
};

const InvoicesType = [
  { label: "SELECT TYPE OF INVOICE", value: "" },
  { label: "Sales Invoice", value: "SALES_INV" },
];

class Sales extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.logoutHandler = this.logoutHandler.bind(this);
    this.clearAllHandler = this.clearAllHandler.bind(this);
    this.searchChangeHandler = this.searchChangeHandler.bind(this);
    this.searchResultHandler = this.searchResultHandler.bind(this);
    this.invoiceDateChangeHandler = this.invoiceDateChangeHandler.bind(this);
    this.checkDates = this.checkDates.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.paginationHandler = this.paginationHandler.bind(this);
  }

  componentWillMount() {
    console.log("inside will mount setting to initial state");
    this.setState(initialState);
  }

  componentWillReceiveProps(nextProps) {
    console.log("next-props=", nextProps);
    if (nextProps.tableData) {
      this.setState({ tabledata: nextProps.tableData });
      this.setState({ records: nextProps.tableData.records });
    } else {
      this.setState({ records: 0 });
    }
    this.setState({ blocking: nextProps.blocking });
    this.setState({ status: nextProps.status });
  }

  logoutHandler = (e) => {
    console.log(" logout call: ");
    e.preventDefault();
    logoutCall();
  };

  invoiceDateChangeHandler(date, key) {
    if (key === "invoiceFromDate") {
      this.setState({ invoiceFromDate: date, toDateErr: "" });
      this.setState({ checkFromDate: false });
      console.log("fromDate:", this.state.fromDate);
      this.checkDates(date, this.state.invoiceToDate);
    } else {
      this.setState({ invoiceToDate: date, toDateErr: "" });
      this.setState({ checkFromDate: false });
      this.checkDates(this.state.invoiceFromDate, date);
    }
  }

  checkDates(fDate, tDate) {
    console.log("fDate:", fDate, "tDate:", tDate);
    if (fDate && tDate) {
      this.setState({ checkFromDate: false });
      if (tDate < fDate) {
        this.setState({
          toDateErr: "*To date should be greater than From date",
        });
      } else {
        this.setState({
          toDateErr: "",
        });
      }
    }
  }

  clearAllHandler() {
    console.log("this.state.value:", this.state);
    this.setState(initialState);

    this.setState({ showSalesResuls: false });
    const { dispatch } = this.props;
    dispatch(userActions.resetTable());
  }

  searchChangeHandler(e) {
    console.log("event:", e);
    const { name, value } = e.target;
    console.log("name:", name, "value:", value);

    if (value === "") {
      this.setState({ [name]: "" });
    } else {
      this.setState({ [name]: value });
    }
  }

  searchResultHandler(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    this.setState({ clearSearch: true });
    this.setState({ clearButton: false });
    var formatfromDate;
    var formattoDate;
    if (this.state.invoiceFromDate != null) {
      formatfromDate = moment(this.state.invoiceFromDate).format("YYYY-MM-DD");
    }
    if (this.state.invoiceToDate != null) {
      formattoDate = moment(this.state.invoiceToDate).format("YYYY-MM-DD");
    }
    const reqBody = {
      supplier: this.state.source,
      vesselName: this.state.vesselName,
      docType: this.state.typeOfInvoice,
      nmsc: this.state.nmsc,
      invoiceFromDate: formatfromDate,
      invoiceToDate: formattoDate,
      edNumber: this.state.edNumber,
      hub: this.state.hub,
      vin: this.state.vinNumber,
      srcVatCode: this.state.srcVatCode,
      tgtVatCode: this.state.tgtVatCode,
      salesInvoiceNumber: this.state.invoiceNumber,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
      username: this.props.loggedInUser.user.userName,
    };
    console.log("reqBody=", reqBody);
    console.log("props=", this.props);
    //let token = this.props.user['x-access-token'];
    this.setState({ tabledata: [] });

    //search API will be used here
    dispatch(userActions.getSales("/sales/searchData/search", reqBody));
    this.setState({ tabledata: this.props.data });
    this.setState({ showSalesResults: true });
    //console.log("states after search button", this.state);
  }

  downloadFile = (e) => {
    console.log("Sales download function.");
    e.preventDefault();
    const { dispatch } = this.props;
    const { file, inv } = e.target.attributes;
    console.log("eventDownload for sales are:", e.target.attributes);
    console.log("file and inv are=", file.value, inv);
    var realFileName = file.value.split("/");

    const reqData = {
      filename: file.value,
      fileDownload: realFileName[1],
    };
    console.log("reqData isss=", reqData);

    dispatch(
      userActions.salesDownloadFile(
        "/salesDownloadData/salesDownload?key=" + reqData.filename,
        reqData
      )
    );
  };

  bulkDownloadFile = (e) => {
    console.log("Multiple File download function for sales", e);
    const { dispatch } = this.props;
    this.state.bulkfilename = e;
    console.log("Multiple fileName:", this.state.bulkfilename);
    dispatch(
      userActions.bulkDownloadSales(
        "/salesDownloadData/salesBulkDownload",
        this.state.bulkfilename
      )
    );
  };

  paginationHandler(pageNumber, pageSize, sortColumnName, sortOrder) {
    const { dispatch } = this.props;
    this.state.multipleDelete = [];
    this.setState({ clearSearch: false });
    this.setState({ clearButton: false });
    var formatfromDate = null;
    var formattoDate = null;
    if (this.state.invoiceFromDate != null) {
      formatfromDate = moment(this.state.invoiceFromDate).format("YYYY-MM-DD");
    }
    if (this.state.invoiceToDate != null) {
      formattoDate = moment(this.state.invoiceToDate).format("YYYY-MM-DD");
    }
    const reqBody = {
      supplier: this.state.source,
      vesselName: this.state.vesselName,
      docType: this.state.typeOfInvoice,
      nmsc: this.state.nmsc,
      invoiceFromDate: formatfromDate,
      invoiceToDate: formattoDate,
      edNumber: this.state.edNumber,
      hub: this.state.hub,
      vin: this.state.vinNumber,
      srcVatCode: this.state.srcVatCode,
      tgtVatCode: this.state.tgtVatCode,
      salesInvoiceNumber: this.state.invoiceNumber,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
      username: this.props.loggedInUser.user.userName,
      size: pageSize ? pageSize : 10,
      index: pageNumber - 1,
      sortOrder: sortOrder,
      sortColumn: sortColumnName,
    };

    this.setState({ tabledata: [] });
    dispatch(userActions.getSales("/sales/searchData/search", reqBody));
    this.setState({ tabledata: this.props.data });
    this.setState({ showSalesResults: true });
  }
  componentWillUnmount() {
    this.setState({ showSalesResuls: true });
  }

  render() {
    {
      console.log("this is sales components props", this.props);
      var NmscNameAndCode = [];
      for (
        var i = 0;
        i < this.props.loggedInUser.user.vlgNMSCsNameAndCode.length;
        i++
      ) {
        NmscNameAndCode.push({
          label: this.props.loggedInUser.user.vlgNMSCsNameAndCode[i][1],
          value: this.props.loggedInUser.user.vlgNMSCsNameAndCode[i][0],
        });
      }

      console.log("nmsc name and code=", NmscNameAndCode);

      var supplierNameAndCode = [];

      for (
        var i = 0;
        i < this.props.loggedInUser.user.vlgSuppliersNameAndCode.length;
        i++
      ) {
        supplierNameAndCode.push({
          label: this.props.loggedInUser.user.vlgSuppliersNameAndCode[i][1],
          value: this.props.loggedInUser.user.vlgSuppliersNameAndCode[i][0],
        });
      }
    }

    console.log("supplier name and code=", supplierNameAndCode);
    return (
      <div>
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          message="Loading, please wait"
          keepInView
        >
          <CommonHeader
            page={"TME VLG Document Portal"}
            username={this.props.loggedInUser.user.userName}
            roles={this.props.loggedInUser.user.roles}
            logoutUser={this.logoutHandler}
            activeLink={"Vehicle Sales Invoices"}
          />

          <SalesSearchBox
            data={this.state}
            SOURCE={supplierNameAndCode}
            VESSELNAME={this.props.loggedInUser.user.vesselName.filter(
              function (el) {
                return el != null && el != "";
              }
            )}
            SRCVATCODE={this.props.loggedInUser.user.srcVatCode.filter(
              function (el) {
                return el != null && el != "";
              }
            )}
            TGTVATCODE={this.props.loggedInUser.user.tgtVatCode.filter(
              function (el) {
                return el != null && el != "";
              }
            )}
            roles={this.props.loggedInUser.user.roles}
            VLGHUB={this.props.loggedInUser.user.vlgHub}
            VLGNMSC={NmscNameAndCode}
            onChangeHandler={this.searchChangeHandler}
            onClear={this.clearAllHandler}
            onSearchHandler={this.searchResultHandler}
            invoiceDateChangeHandler={this.invoiceDateChangeHandler}
            InvoicesType={InvoicesType}
            OneRandomInput={
              this.state.invoiceToDate != null ||
              this.state.invoiceFromDate != null ||
              this.state.source != "" ||
              this.state.nmsc != "" ||
              this.state.invoiceNumber != "" ||
              this.state.vinNumber != "" ||
              this.state.edNumber != "" ||
              this.state.vesselName != "" ||
              this.state.hub != "" ||
              this.state.srcVatCode != "" ||
              this.state.tgtVatCode != ""
                ? false
                : true
            }
          />

          <SalesDataTable
            paginationHandler={this.paginationHandler}
            data={this.state.tabledata}
            showSalesResults={this.state.showSalesResults}
            onDownloadClick={this.downloadFile}
            searchClear={this.state.clearSearch}
            clearButton={this.state.clearButton}
            onBulkDowloadHandler={this.bulkDownloadFile}
          />
        </BlockUi>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggedInUser } = state.loginReducer;
  console.log("LogginUser:", loggedInUser);
  const { tableData, blocking } = state.searchData;
  return {
    loggedInUser,
    tableData,
    blocking,
  };
}

const SalesConnected = connect(mapStateToProps)(Sales);
export { SalesConnected as Sales };
